module.exports = __webpack_public_path__ + "img/almoxarifado_estoque.1e0114ad.png";